import React from 'react';
import { TableHeaderProps } from '../../../types';
import TableRow from './TableRow';
import './TableHeader.css';

const TableHeader: React.FC<TableHeaderProps> = ({
  headers,
  className = ''
}) => {
  const headerClasses = `table-header ${className}`.trim();
  
  return (
    <TableRow isHeader className={headerClasses}>
      {headers.map((header, index) => (
        <div key={index} className="table-header-cell">
          {header}
        </div>
      ))}
    </TableRow>
  );
};

export default TableHeader;
